/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SniIndustryType } from '../../types';

type SniIndustriesStateType = {
    all: SniIndustryType[],
    fetching: boolean
};

const initialState: SniIndustriesStateType = {
    all: [],
    fetching: false
};

const slice = createSlice({
    name: 'sni',
    initialState,
    reducers: {
        fetch: (state) => {
            state.fetching = true;
        },
        fetched: (state, action: PayloadAction<{data: SniIndustriesStateType['all']}>) => {
            state.all = action.payload.data;
            state.fetching = false;
        }
    }
});

export default slice;
